import { render, staticRenderFns } from "./NoChangeNotice.vue?vue&type=template&id=4fb23882"
import script from "./NoChangeNotice.vue?vue&type=script&lang=js"
export * from "./NoChangeNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports